module.exports = new __parcel__URL__("approvals-preview.ce5f015e.svg").toString();